(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("businesscoSettingSmtpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 235,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 236,
                    parameters: edit
                });
            },
            testSmtpEmail: function (edit) {
                return $ihttp.post({
                    method: 237,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
